import React from 'react';
import FairPriceView from '@/components/polymer/FairPriceView';
import UsitcChart from '@/components/polymer/UsitcChart';
import FeedstocksTab from '@/components/polymer/FeedstocksTab';
import PolymerDashboardLayout from '@/components/polymer/PolymerDashboardLayout';
import type { PolymerDashboardConfig } from '@/types/polymer-dashboard.types';

const DEFAULT_DATE_FROM = (() => {
  const d = new Date();
  d.setFullYear(d.getFullYear() - 5);
  return d.toISOString().split('T')[0];
})();
const DEFAULT_DATE_TO = new Date().toISOString().split('T')[0];

const PC_CONFIG: PolymerDashboardConfig = {
  polymer: 'PC',
  polymerFullName: 'Polycarbonate',
  defaultTab: 'overview',
  tabs: [
    { key: 'overview', label: 'Overview' },
    { key: 'fair-price', label: 'Fair Resin Price' },
    { key: 'feedstocks', label: 'Feedstocks' },
    { key: 'usitc', label: 'PC USITC' },
  ],
};

const ChartPanel: React.FC<{ title: string; children: React.ReactNode; className?: string }> = ({ title, children, className }) => (
  <div className={`bg-rs-off-black/60 backdrop-blur-sm border border-rs-jet-light/50 rounded-xl shadow-lg shadow-black/20 p-5 ${className || ''}`}>
    <h3 className="text-sm font-medium text-rs-off-white/70 uppercase tracking-wider mb-4">{title}</h3>
    {children}
  </div>
);

const PCDashboard: React.FC = () => {
  const renderContent = (activeTab: string) => {
    if (activeTab === 'overview') {
      return (
        <div className="flex flex-col gap-6">
          <ChartPanel title="Fair Resin Price">
            <FairPriceView polymer="PC" dateFrom={DEFAULT_DATE_FROM} dateTo={DEFAULT_DATE_TO} labelMode="overview" />
          </ChartPanel>
          <ChartPanel title="Feedstocks">
            <FeedstocksTab polymer="PC" />
          </ChartPanel>
        </div>
      );
    }

    switch (activeTab) {
      case 'fair-price':
        return <FairPriceView polymer="PC" dateFrom={DEFAULT_DATE_FROM} dateTo={DEFAULT_DATE_TO} labelMode="tab" fullBleed />;
      case 'feedstocks':
        return <FeedstocksTab polymer="PC" fullBleed />;
      case 'usitc':
        return <UsitcChart polymer="PC" dateFrom={DEFAULT_DATE_FROM} dateTo={DEFAULT_DATE_TO} />;
      default:
        return null;
    }
  };

  return (
    <PolymerDashboardLayout config={PC_CONFIG} renderContent={renderContent} />
  );
};

export default PCDashboard;
